import { smartHttp } from '@/utils/http/index.js';
/**
 * 原始数据列表
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/21725
 */
export function planOriginalInfoList(data, params) {
    return smartHttp.request({
        url: '/plan/original/info/list',
        method: 'post',
        data,
        params
    });
}

/**
 * 重新提交排线
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/21727
 */
export function planMsgCreate(data) {
    return smartHttp.request({
        url: '/plan_msg/create',
        method: 'post',
        data
    });
}
